import { useEffect } from 'react';
import { ChannelListMessengerProps } from 'stream-chat-react';
import { makeStyles } from '@material-ui/styles';

import { useChatClient } from '@bizzabo/chat-core';

import { useMessages, View } from '../../../contexts/MessagesContext';
import Loader from '../Loader';

const CustomChannelList: React.FC<ChannelListMessengerProps> = ({ children, loading }) => {
    const classes = useStyles();
    const { view } = useMessages();
    const { setActiveChannel } = useChatClient();

    useEffect(() => {
        if (view === View.ChannelList) {
            setActiveChannel(null);
        }
    }, [setActiveChannel, view]);
    return (
        <div className={classes.listContainer}>
            <div className={classes.listItemsWrapper}>{loading ? <Loader /> : children}</div>
        </div>
    );
};

const useStyles = makeStyles(
    {
        listContainer: {
            height: '100%',
        },
        listItemsWrapper: {
            height: '100%',
            overflowY: 'auto',
        },
    },
    { classNamePrefix: CustomChannelList.name }
);

export default CustomChannelList;
